import React from 'react';

import { NotFoundProps } from './NotFound.props';

import NotFoundView from './NotFound.view';

const NotFoundContainer = (props: NotFoundProps) => {
  return <NotFoundView />;
};

export default NotFoundContainer;
